import React from 'react';
import { StethoscopeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { AUTHOR_IMAGE } from '../../data/content';
const credentials = ['Physician focused on clinical decision-making and men’s sexual health', 'Builds clinical systems from AUA, EAU, ISSM, ESH and ESC evidence', 'Trains physicians to structure consultations instead of memorizing pages'];
export function About() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-61" data-mp="b0isfqe79q59">
      <div className="mx-auto w-full max-w-5xl px-5" data-id="element-62" data-mp="60wetfugm7vx">
        <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:items-center lg:gap-12" data-id="element-63" data-mp="62h87251fks7">
          <div className="mx-auto w-full max-w-[320px] overflow-hidden rounded-3xl border border-slate-200 bg-slate-100" data-id="element-64" data-mp="jtlyhdmin0pv">
            <img src={AUTHOR_IMAGE} alt="Dr. Karito, physician and author of the Clinical Route for Erectile Dysfunction" className="h-full w-full object-cover" loading="lazy" data-id="element-65" data-mp="ez83hcbrmvlq" />
          </div>

          <div data-id="element-66" data-mp="338gtlnbxbdou">
            <p className="flex items-center gap-2 text-[0.7rem] font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-67" data-mp="338p4xaseeaxx">
              <StethoscopeIcon className="h-4 w-4" aria-hidden="true" data-id="element-68" data-mp="385yt6n41wgk6" />
              About Dr. Karito
            </p>
            <h2 className="mt-3 font-display text-[1.7rem] font-extrabold leading-tight tracking-tight text-navy-900 sm:text-4xl" data-id="element-69" data-mp="3hy4skhwmu09e">
              The physician behind the Clinical Route
            </h2>
            <div className="mt-4 space-y-3 text-[0.97rem] leading-relaxed text-slate-600" data-id="element-70" data-mp="2p97d0mjt2hkc">
              <p data-id="element-71" data-mp="2u8k1fbqbrwp1">
                Dr. Karito created this system after seeing the same pattern in
                consultation after consultation: the information already exists,
                but nothing tells you what matters for the patient sitting in
                front of you.
              </p>
              <p data-id="element-72" data-mp="eh5w18c08je1">
                So instead of writing another 300-page review, she turned the
                current evidence into decision pathways, checkpoints, and
                consultation tools you can actually open during the visit.
              </p>
            </div>

            <ul className="mt-6 space-y-2.5" data-id="element-73" data-mp="25ntxdo8cub8c">
              {credentials.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-slate-50 px-4 py-3 text-[0.9rem] leading-snug text-slate-700 ring-1 ring-slate-200" data-id="element-74" data-mp="2jj4ocqjhac7f">
                  <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-brand-500" aria-hidden="true" data-id="element-75" data-mp="1muyhry2zx9qi" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 max-w-md" data-id="element-76" data-mp="1vuuxha7eqy9f">
              <CTAButton label="I want Dr. Karito’s clinical system" note="Immediate access · One-time payment" data-id="element-77" data-mp="1vttkv1aqu3pl" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}